// acessoProjetos.js — quem enxerga o módulo Projetos (lado do navegador)
//
// ⚠️ ESTE ARQUIVO NÃO PROTEGE NADA. Ele só decide se o item aparece no menu e se
//    a rota /projetos abre. Tudo que roda no navegador é editável pelo usuário.
//    A AUTORIDADE é o backend: server/projetos/acesso-projetos.js — é lá que o
//    dado é negado (403), e é lá que a lista deve ser alterada primeiro.
//
// A duplicação é consciente: o menu precisa da resposta na hora de renderizar,
// e uma chamada ao servidor só para desenhar um item de sidebar não se paga.
//
// Por que por USUÁRIO e não por perfil: o Inventário Executivo é o
// acompanhamento pessoal do CEO. Quando o módulo nasceu ele era `Diretoria`,
// perfil de 8 pessoas — autorizar por perfil abriria o inventário às outras 7.
//
// ⚠️ Desde 2026-08-04 ele tem perfil próprio (`Presidencia`), e a lista por ID
//    ficou de propósito: o PERFIL governa a navegação (o que ele enxerga do
//    portal), esta lista governa o CONTEÚDO (quem lê o inventário). Detalhe do
//    porquê em server/projetos/acesso-projetos.js, que é a autoridade.

// Espelho de IDS_AUTORIZADOS do backend. Mudou lá, muda aqui.
export const IDS_PROJETOS = [
    44, // MARCO ANTONIO BRAGA CORREIA (marco.correia) — dono do inventário
];

/**
 * O usuário logado pode ver o módulo Projetos?
 *
 * ⚠️ SEM bypass de Admin — exceção única no portal (2026-08-04). O conteúdo é
 *    restrito ao dono, e a equipe de dados é composta de Admins: manter o
 *    bypass tornaria a restrição decorativa.
 *
 * É esta função que também tira o item do menu lateral (Sidebar.js), sem
 * precisar de regra própria lá.
 */
export function podeVerProjetos(user) {
    if (!user) return false;
    return IDS_PROJETOS.includes(Number(user.id));
}
